import { i18n } from '@/lang/i18n';
import { environmentService, postRequestHandler } from '@/utils/services';

const DefaultState = () => {
        return {
            apiUrl: null,
            roomtypes: [],
            selectedHotel: null,
            quickviewRate: {
                showroomtype: null,
                showrateplan: null,
                showdate: null,
                currency: null,
                record: [],
            },
            selectedInventory: [],
            selectedbox: [],
            searchCounter: 0,
            inventory: [],
            gridUpdate:false,
            updatedData:null
        };
    },

    state = DefaultState(),

    getters = {
        roomtypes: state => state.roomtypes,
        selectedHotel: state => state.selectedHotel,
        quickviewRate: state => state.quickviewRate,
        searchCounter: state => state.searchCounter,
        selectedInventory: state => state.selectedInventory,
        selectedbox: state => state.selectedbox,
        inventory: state => state.inventory,
        gridUpdate: state => state.gridUpdate,
        updatedData: state => state.updatedData
    },

    mutations = {
        setInventory(state, payload) {
          state.inventory = payload.data;
          state.selectedInventory = payload.data;
        },
        setRoomTypes(state, payload) {
            state.roomtypes = payload;
            state.searchCounter += 1;
        },
        selectInventory(state, payload) {
            state.selectedInventory = [];
            if (payload.includes("all")) {
                state.selectedbox = []
                state.inventory.forEach(element => {
                    state.selectedInventory.push({
                        additionals: element.additionals,
                        description: element.description,
                        guests: element.guests,
                        hotel_id: element.hotel_id,
                        id: element.id,
                        inventories: element.inventories,
                        name: element.name
                    });
                });
                state.roomtypes.forEach(element => {
                    state.selectedbox.push(element.id)
                })
            }
            if (payload.includes("uncheck")) {
                state.selectedInventory = []
                state.selectedbox = []
            }
            if (!payload.includes("all") && payload.length <= state.inventory.length) {
                state.selectedbox = []
                state.inventory.forEach(element => {
                    if (payload.includes(element.id)) {
                        state.selectedInventory.push({
                            additionals: element.additionals,
                            description: element.description,
                            guests: element.guests,
                            hotel_id: element.hotel_id,
                            id: element.id,
                            inventories: element.inventories,
                            name: element.name
                        });
                        state.selectedbox.push(element.id)
                    }
                });
            }
        },
        setQuickviewRate(state, payload) {
            state.quickviewRate.showroomtype = payload.roomtype.name;
            state.quickviewRate.showrateplan = payload.rateplan.name;
            state.quickviewRate.record = _.filter(payload.rateplan.rates, function(o, index) {
                return o.date == payload.item.date;
            });
            if (payload.action == 'create') {
                state.quickviewRate.showdate = payload.item.date;
                state.quickviewRate.currency = payload.item.currency;
            } else if (payload.action == 'update') {
                state.quickviewRate.showdate = payload.item.date;
                state.quickviewRate.currency = payload.rateplan.currency;
            }
            if (payload.action == 'new') {
                document.querySelector("#quickviewNewRate").classList.add("is-active");
            } else {
                document.querySelector("#quickviewEditRate").classList.add("is-active");
            }
        },
        setRoomUrls(state) {
            state.apiUrl = environmentService.apiUrlHotel;
        },
        setSelectedHotel(state, payload) {
            state.selectedHotel = payload;
        },
        setGridUpdate(state, payload){
            if (payload.status && payload.data ) {
                state.updatedData = payload.data;
            } else {
                state.updatedData = null;
            }
            state.gridUpdate = payload.status;
        },
        RESET_RATE_TO_SHOW(state) {
            Object.assign(state.quickviewRate, DefaultState().quickviewRate);
        },
        RESET_SELECTED_BOX(state) {
            state.selectedInventory = [];
            state.selectedbox = [];
        }
    },

    actions = {
        setRoomUrls({ commit }) {
            commit('setRoomUrls');
        },
        selectInventory({ commit }, payload) {
            commit('selectInventory', payload);
        },
        setSelectedHotel({ commit }, payload) {
            commit('setSelectedHotel', payload);
        },
        setQuickviewRate({ commit }, payload) {
            commit('setQuickviewRate', payload);
        },
        setInventory({ commit }, payload) {
            commit('setInventory', payload);
        },
        setGridUpdate({ commit }, payload) {
            commit('setGridUpdate', payload);
        },
        async getRoomTypes({ commit, state, rootState }, payload) {
            let rooms = await postRequestHandler(`${state.apiUrl}/hotels/roomtypes`, payload, { headers: rootState.auth.headers });
            commit('setRoomTypes', rooms.roomtypes);
        },

        async searchInventory({ commit, state, rootState }, payload) {
            let inventory = await postRequestHandler(`${state.apiUrl}/hotels/inventory`, state.selectedHotel, { headers: rootState.auth.headers });
        },

        async updateInventory({ commit, state, dispatch, rootState}, payload) {
          i18n.locale = rootState.global.locale;
          const result = await postRequestHandler(`${state.apiUrl}/hotels/inventory/create`, payload, {headers: rootState.auth.headers});
          this.isLoading = false;
            if (result.data.status == 200) {
                commit('setGridUpdate', {status: true, data: result.data.data});
                dispatch('global/setToastNotification', {title: i18n.t('lang.store.inventory.inventory'), text: i18n.t('lang.store.inventory.updateSuccess'), type:'success'}, {root:true});
            } else {
                commit('setGridUpdate', {status: true, data: null});
                let errors = "";
                result.data.errors.forEach(element => {
                    errors = errors + "<br>" + element;
                });
              dispatch('global/setToastNotification', {title: i18n.t('lang.store.inventory.inventory'), text: errors, type:'danger'}, {root:true});
            }
        },
        RESET_RATE_TO_SHOW({ commit }) {
            commit('RESET_RATE_TO_SHOW');
        }
    };

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};



// WEBPACK FOOTER //
// ./src/store/modules/inventory.js